// Function to find if a value is numeric or not
// 12 true
// '12' true
// 'abc' false
export const isNumeric = (value) => {
    if (!value) return false;

    return !isNaN(parseFloat(value)) && isFinite(value);
};
